/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './gynaec-history.reducer';

export const GynaecHistoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const gynaecHistoryEntity = useAppSelector(state => state.gynaecHistory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="gynaecHistoryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.gynaecHistory.detail.title">GynaecHistory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.id">Id</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.id}</dd>
          <dt>
            <span id="lmp">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.lmp">Lmp</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.lmp}</dd>
          <dt>
            <span id="menarche">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.menarche">Menarche</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.menarche}</dd>
          <dt>
            <span id="periodRegular">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.periodRegular">Period Regular</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.periodRegular}</dd>
          <dt>
            <span id="periodCycleInterval">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.periodCycleInterval">Period Cycle Interval</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.periodCycleInterval}</dd>
          <dt>
            <span id="parity">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.parity">Parity</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.parity}</dd>
          <dt>
            <span id="loss">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.loss">Loss</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.loss}</dd>
          <dt>
            <span id="pain">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.pain">Pain</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.pain}</dd>
          <dt>
            <span id="vaginalDischarge">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.vaginalDischarge">Vaginal Discharge</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.vaginalDischarge}</dd>
          <dt>
            <span id="endOfMenopause">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.endOfMenopause">End Of Menopause</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.endOfMenopause}</dd>
          <dt>
            <span id="imb">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.imb">Imb</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.imb ? 'true' : 'false'}</dd>
          <dt>
            <span id="papSmear">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.papSmear">Pap Smear</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.papSmear ? 'true' : 'false'}</dd>
          <dt>
            <span id="papSmearResult">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.papSmearResult">Pap Smear Result</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.papSmearResult}</dd>
          <dt>
            <span id="papSmearDate">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.papSmearDate">Pap Smear Date</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.papSmearDate}</dd>
          <dt>
            <span id="infertilityHist">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.infertilityHist">Infertility Hist</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.infertilityHist ? 'true' : 'false'}</dd>
          <dt>
            <span id="breastFeeding">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.breastFeeding">Breast Feeding</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.breastFeeding ? 'true' : 'false'}</dd>
          <dt>
            <span id="historyOfDES">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.historyOfDES">History Of DES</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.historyOfDES ? 'true' : 'false'}</dd>
          <dt>
            <span id="desObservation">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.desObservation">Des Observation</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.desObservation}</dd>
          <dt>
            <span id="desDate">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.desDate">Des Date</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.desDate}</dd>
          <dt>
            <span id="sbe">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.sbe">Sbe</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.sbe ? 'true' : 'false'}</dd>
          <dt>
            <span id="sbeObsv">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.sbeObsv">Sbe Obsv</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.sbeObsv}</dd>
          <dt>
            <span id="sbeDate">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.sbeDate">Sbe Date</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.sbeDate}</dd>
          <dt>
            <span id="momogram">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.momogram">Momogram</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.momogram ? 'true' : 'false'}</dd>
          <dt>
            <span id="momogramObsv">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.momogramObsv">Momogram Obsv</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.momogramObsv}</dd>
          <dt>
            <span id="mamogramDate">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.mamogramDate">Mamogram Date</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.mamogramDate}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.active">Active</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{gynaecHistoryEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.gynaecHistory.patient">Patient</Translate>
          </dt>
          <dd>{gynaecHistoryEntity.patient ? gynaecHistoryEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/gynaec-history" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/gynaec-history/${gynaecHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default GynaecHistoryDetail;
